export const ApiTags = {
    Achievements: 'Achievements',
    Prompts: 'Prompts',
    Courses: 'Courses',
    Challenges: 'Challenges',
    Leaderboard: 'Leaderboard',
    Search: 'Search',
    Feed: 'Feed',
    Users: 'Users',
    UserAgreement: 'UserAgreement',
    Likes: 'Likes',
    Slides: 'Slides',
} as const;
